import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';
import '../App.css';

const LandingPage = () => {
  const [whatsapp, setWhatsapp] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const phoneParam = searchParams.get('p');
    if (phoneParam) {
      const formattedPhone = phoneParam.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4');
      setWhatsapp(formattedPhone);
    }
  }, [location.search]);

  const handleSave = () => {
    const unmaskedWhatsapp = whatsapp.replace(/\D/g, '');
    const whatsappLink = `https://wa.me/${unmaskedWhatsapp}?text=Ol%C3%A1%21%20Queria%20te%20indicar%20o%20Multipedidos%2C%20um%20card%C3%A1pio%20digital%20e%20sistema%20de%20gest%C3%A3o%20para%20delivery%20super%20pr%C3%A1tico%20e%20sem%20comiss%C3%B5es%21%20Mais%20de%204500%20restaurantes%20j%C3%A1%20utilizam%20em%20todo%20o%20Brasil%2C%20e%20com%20esse%20link%20voc%C3%AA%20tem%20100%25%20de%20desconto%20na%20taxa%20de%20implanta%C3%A7%C3%A3o.%20Segue%20abaixo%20o%20link%20para%20cadastro%3A%0A%0Ahttps%3A%2F%2Fconvite.multipedidos.com.br%2F%3Fr%3D${unmaskedWhatsapp}`;
    window.location.href = whatsappLink;
  };

  return (
    <div className="lp-background">
        <div className='lp-container'>
            <img src='/mp-logo.png' alt='logo mp'/>
            <h2>Conhece um restaurante que ainda não usa o link <span style={{fontStyle: 'italic'}}>pedir.delivery</span> da Multipedidos? Indique e ganhe um <span style={{color: '#ff6600', textShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', fontWeight: 800}}>Cupom de R$100,00 </span>para aproveitar nele assim que eles se juntarem a nós!</h2>
            <h3>Além disso, com seu link, o restaurante ganha 100% de isenção na taxa de implantação</h3>
            <div className='whatsapp-form-container'>
                <p>Basta preencher seu WhatsApp abaixo para salvar o link de indicação</p>
                <InputMask
                    mask="(99) 9 9999-9999"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    required
                    ref={inputRef}
                >
                    {(inputProps) => <input {...inputProps} type="text" className="lp-input" />}
                </InputMask>
                <button onClick={handleSave} className="lp-button">
                    Salvar Link no WhatsApp
                </button>
            </div>
            <p>
                Caso o restaurante indicado feche com a gente, você receberá o cupom diretamente em seu WhatsApp.
            </p>
        </div>
    </div>
  );
};

export default LandingPage;
